import script from "./LikeShop.vue?vue&type=script&lang=ts&setup=true"
export * from "./LikeShop.vue?vue&type=script&lang=ts&setup=true"

import "./LikeShop.vue?vue&type=style&index=0&id=4ed48cee&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed48cee"]])

export default __exports__